import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { OfferSelectionCardModel, TextModel } from '@flocasts/experience-service-types'
import { take } from 'rxjs'
import {
  FEAT_SINGLE_CLICK_DESKTOP_PLANS_ID,
  FEAT_SINGLE_CLICK_DESKTOP_PLANS_VARIATION
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'
import { getFirstWord, getSecondWord } from 'src/app/shared/utility-functions/string.utility'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-offer-button-card',
  templateUrl: './offer-button-card.component.html',
  styleUrls: ['./offer-button-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferButtonCardComponent {
  @Input()
  offer: OfferSelectionCardModel
  @Input()
  buttonText = 'Sign Up'
  @Input()
  pricePeriod = '/mo'
  @Input()
  showMoreBillingInfo = false
  @Input()
  showSavings = false
  @Input()
  showValueProps = false
  @Input()
  showSavingsValueProp = false
  @Input()
  isMonthly?: boolean
  @Output()
  offerSelected = new EventEmitter<OfferSelectionCardModel>()

  public trackById = trackById

  public get savingsLabel(): string {
    return getFirstWord(this.offer.caption?.text)
  }

  public get savingsAmount(): string {
    return getSecondWord(this.offer.caption?.text)
  }

  public get billingInfo(): string {
    return this.showMoreBillingInfo
      ? this.isMonthly
        ? `${this.offer.priceLabel} billed monthly`
        : `${this.offer.yearlyPriceLabel} billed annually`
      : this.offer.subtitle
  }

  public get bulletPoints(): TextModel[] {
    return this.showSavingsValueProp
      ? this.offer.bulletPoints
      : this.offer.bulletPoints?.filter((bullet: TextModel) => !bullet.text?.includes('Save'))
  }

  handleClick(offer: OfferSelectionCardModel): void {
    this.offerSelected.emit(offer)
  }
}
